import React, {useEffect, useMemo, useRef} from 'react';

const MOBILE_APP_URL = process.env.REACT_APP_MOBILE_APP_URL || 'http://127.0.0.1:8082/';
const MOBILE_BACK_MESSAGE = 'TAIFUN_MOBILE_BACK';

const MobileAppPage = () => {
    const iframeRef = useRef<HTMLIFrameElement>(null);
    const mobileAppOrigin = useMemo(() => {
        try {
            return new URL(MOBILE_APP_URL).origin;
        } catch {
            return '*';
        }
    }, []);

    useEffect(() => {
        window.history.replaceState({taifunMobileShell: true}, '', window.location.href);
        window.history.pushState({taifunMobileShell: true}, '', window.location.href);

        const handleBack = () => {
            iframeRef.current?.contentWindow?.postMessage({type: MOBILE_BACK_MESSAGE}, mobileAppOrigin);
            window.history.pushState({taifunMobileShell: true}, '', window.location.href);
        };

        window.addEventListener('popstate', handleBack);

        return () => {
            window.removeEventListener('popstate', handleBack);
        };
    }, [mobileAppOrigin]);

    return (
        <div className="mobile-app-shell">
            <iframe
                ref={iframeRef}
                className="mobile-app-frame"
                src={MOBILE_APP_URL}
                title="Taifun ERP Mobile"
            />
        </div>
    );
};

export default MobileAppPage;
